import { memo } from "react";
import { useSelector } from "react-redux";

import { locationTabs } from "../../../consts/tabs";

import {
  routesForPlanTypeSelector,
  depotSectionsSelector,
  getMatrixProfileMessage,
  locationListSelector,
} from "../../../reducers/matrixProfile/selectors";

import { InfoMessage } from "../../InfoMessage";
import { RouteDetail } from "../../RouteDetail";
import { SectionMenu } from "..";
import Sections from "../../Sections";
import Locations from "../../Locations";

export const LocationSections = memo(() => {
  const message = useSelector(getMatrixProfileMessage);
  const depotSections = useSelector(depotSectionsSelector);
  const routes = useSelector(routesForPlanTypeSelector);
  const locationList = useSelector(locationListSelector);

  return (
    <SectionMenu tabs={locationTabs}>
      {message && <InfoMessage message={message} />}
      {!message && depotSections && (
        <SectionMenu.SectionMenuItem id={0}>
          <Sections sections={depotSections} />
        </SectionMenu.SectionMenuItem>
      )}
      {!message && routes && (
        <SectionMenu.SectionMenuItem id={1}>
          <RouteDetail routes={routes} />
        </SectionMenu.SectionMenuItem>
      )}
      {!message && locationList && (
        <SectionMenu.SectionMenuItem id={2}>
          <Locations locationList={locationList} />
        </SectionMenu.SectionMenuItem>
      )}
    </SectionMenu>
  );
});
